import WorkersRequest from '../ws/WorkersRequest';
import WorkersStateRequest from '../ws/WorkersStatesRequest';
import Alert from 'react-s-alert';
import WorkerRequest from '../ws/WorkerRequest';

export const WORKER_UPDATE = 'worker-update';
export const WORKERS_UPDATE = 'workers-update';
export const WORKER_REMOVE = 'worker-remove';
export const WORKERS_LOADING = 'workers-loading';
export const WORKERS_ERROR = 'workers-error';
export const WORKERS_STATE_UPDATE = 'workers-state-update';

export const WORKER_ADD_LOADING = 'worker-add-loading';

export const WORKER_LIST_CLEAR = 'worker-list-clear';

export const COMPANIES_FETCH_SUCCEED = 'task-form-companies-fetch-succeed';
export const COMPANIES_FETCH_LOADING = 'task-form-companies-fetch-loading';

export const clearWorkerList = () => (dispatch) => {
    dispatch({
        type: WORKER_LIST_CLEAR,
    });
};

export const getWorkers = (
    page = 1,
    search = '',
    filter = 0,
    companyId = null,
    includeOnlyContractorWorkers = false,
    includeOnlyCompanyWorkers = false,
) => (dispatch) => {

    new WorkersRequest(
        page,
        search,
        filter,
        companyId,
        false,
        includeOnlyContractorWorkers,
        includeOnlyCompanyWorkers,
    )
        .onPreExecution(() => {
            dispatch({
                type: WORKERS_LOADING,
                payload: true,
            });
        })
        .onSuccess(data => {
            dispatch({
                type: WORKERS_UPDATE,
                payload: data,
            });
        })
        .onFail(error => {
            dispatch({
                type: WORKERS_ERROR,
                payload: error,
            });
        })
        .onPostExecution(() => {
            dispatch({
                type: WORKERS_LOADING,
                payload: false,
            });
        })
        .execute();
};

export const getWorkersDeleted = (page = 1, search = '', filter = 0, companyId = null) => (dispatch) => {

    new WorkersRequest(page, search, filter, companyId, true)
        .onPreExecution(() => {
            dispatch({ type: WORKERS_LOADING, payload: true });
        })
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: WORKERS_UPDATE,
                payload: data,
            });
        })
        .onFail(error => {
            dispatch({ type: WORKERS_ERROR, payload: error });
        })
        .onPostExecution(() => {
            dispatch({ type: WORKERS_LOADING, payload: false });
        })
        .execute();
};

export const getWorker = (id) => (dispatch) => {

    new WorkerRequest(id)
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: WORKER_UPDATE,
                payload: data,
            });
        })
        .execute();
};

export const getWorkersStates = () => (dispatch) => {

    new WorkersStateRequest()
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: WORKERS_STATE_UPDATE,
                payload: data,
            });
        })
        .execute();
};

export const showAlert = () => (dispatch) => {

    Alert.success('<p>Alerta<br><a>Link</a></p>', {
        html: true,
    });

};



// WEBPACK FOOTER //
// ./src/app/worker/actions/workerActions.js